// extracted by mini-css-extract-plugin
var _1 = "ButtonStyle-module__tooltip___gq9SN";
var _2 = "ButtonStyle-module__tooltip--wrapper___YkCMI";
var _3 = "ButtonStyle-module__tooltip--wrapper___YkCMI";
export { _1 as "tooltip", _2 as "tooltip--wrapper", _3 as "tooltipWrapper" }
